import { AcceleratedDepreciationItem } from '../types'

export const initializeDepreciationAmount = (
  monthlyDepreciation: AcceleratedDepreciationItem[],
  memorandumValue?: number | null,
  residualValue?: number | null
) => {
  const _monthlyDepreciation = monthlyDepreciation.map(item => ({ ...item }))

  const indexFirstAdjustableItem = _monthlyDepreciation.findIndex(record => record.is_adjustable)
  const numberOfAdjustableItem = _monthlyDepreciation.filter(record => record.is_adjustable).length

  if (indexFirstAdjustableItem < 0) return _monthlyDepreciation

  const endBookValue = memorandumValue || residualValue || 0
  const beginningBookValue = _monthlyDepreciation[indexFirstAdjustableItem].beginning_book_value as number
  const bookValue = beginningBookValue - endBookValue
  const depreciationAmountChanged = Math.floor(bookValue / numberOfAdjustableItem)

  _monthlyDepreciation.forEach((item, index) => {
    if (item.is_adjustable) {
      item.unEditable = bookValue === 0
      item.depreciation_amount = depreciationAmountChanged
      if (index === _monthlyDepreciation.length - 1) {
        item.depreciation_amount = bookValue - depreciationAmountChanged * (numberOfAdjustableItem - 1)
      }
      if (index === indexFirstAdjustableItem) {
        item.end_of_term_book_value = beginningBookValue - item.depreciation_amount
      } else {
        item.end_of_term_book_value =
          (_monthlyDepreciation[index - 1].end_of_term_book_value as number) - item.depreciation_amount
      }
    }
  })

  return _monthlyDepreciation
}
